/** Local SDK testing is opt-in and still requires the visitor's category consent. */
export function isAnalyticsEnabled(): boolean {
  return import.meta.env.PROD || import.meta.env.VITE_ENABLE_ANALYTICS === 'true';
}
